export default "__VITE_ASSET__CyKnS785__"